import React, { Component } from 'react'
import { Modal, message, Checkbox, Spin } from 'antd';
import QRCode from 'qrcode.react';
import './index.css';
import https from '@/utils/ajaxUtils';
import Urls from '@/config/url';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

//服务条款内容
const serviceContent = ` <div class="server-content">
<div class="center">中科计算技术西部研究院</div>
<div class="center">知识图谱服务条款</div>
<div>&emsp;&emsp;更新日期：2021年10月</div>
<div>&emsp;&emsp;欢迎来到TWiRLs<span class="transform">棍棍</span>！</div>
<div>
&emsp;&emsp;TWiRLs<span class="transform">棍棍</span>是由中科计算技术西部研究院（下称“西研院”）提供的互联网软件服务。本服务条款（下称“服务条款”）是您与西研院之间关于您（“您”或“用户”）访问和使用TWiRLs<span class="transform">棍棍</span>以及西研院提供的其他服务（下称“服务”）的主要协议。<span class="strong underline bgc">您注册、登录TWiRLs<span class="transform">棍棍</span>和/或使用西研院提供的服务，即表示您同意接受服务条款，如您不同意该协议，请不要使用本服务。</span>因此，敬请仔细阅读。
</div>
<div><span class="no-underline">&emsp;&emsp;</span><span class="underline strong">西研院有权不时地对服务条款做任何修改和补充，并在TWiRLs<span class="transform">棍棍</span>网站上公布。服务条款的修改和补充将在公布时立即生效。您继续访问和使用TWiRLs<span class="transform">棍棍</span>即视为您接受修订后的服务条款。如您不同意修订后的服务条款，您应停止访问TWiRLs<span class="transform">棍棍</span>并拒绝使用服务或删除您在TWiRLs<span class="transform">棍棍</span>上的信息和帐户来终止接受服务。</span></div>
<div ><span>&emsp;&emsp;</span><span class="underline strong">如果您代表某个机构而非您个人注册、登录和使用TWiRLs<span class="transform">棍棍</span>和/或我们其他的服务，则您将被认为获得充分授权代表该机构同意本服务条款以及不时修订和补充的服务条款。</span></div>
<div>&emsp;&emsp;<span>1.服务内容</span></div>
<div>
&emsp;&emsp;TWiRLs<span class="transform">棍棍</span>的具体服务由西研院根据实际情况提供，例如报告生成以及医学资料和医学案列在线查询等服务。为不断提升用户体验，西研院会不时为用户提供其他服务内容，届时，可能与您另行签订其他专项协议。但即使未另行签订其他专项协议，您使用TWiRLs<span class="transform">棍棍</span>的具体服务时，也将被视为您同意西研院关于该等具体服务的任何要求。如果其他专项协议和本条款之间存在冲突，应以其他专项协议为准，但以该冲突和与该协议特定事宜相关为限。
</div>
<div><span>&emsp;&emsp;</span><span class="underline strong">西研院保留随时变更、中止或终止免费服务的权利，并保留根据实际情况随时调整TWiRLs<span class="transform">棍棍</span>提供的服务种类、形式的权利。西研院不承担因TWiRLs<span class="transform">棍棍</span>提供的任何免费服务的调整给您造成的损失。</span> <span>尽管有本条约定，西研院有权在未来恰当的时机对该等免费服务内容收取相应的服务费用。西研院保留随时终止向您提供的收费服务的权利，并保留根据实际情况随时调整TWiRLs<span class="transform">棍棍</span>提供的收费服务种类和形式的权利。如果西研院终止提供某项收费服务，西研院的义务仅在于向您返还您尚未使用的服务期对应的部分费用。但无论如何，西研院将尽合理的努力为您预留合理的时间以便您为该等服务的变更、中止或终止做出应对。</span></div>
<div>&emsp;&emsp;<span>2.注册</span></div>
<div>
&emsp;&emsp;为了能访问TWiRLs<span class="transform">棍棍</span>和使用服务，您同意以下事项：依TWiRLs<span class="transform">棍棍</span>网站提示填写准确的、真实的注册手机号码、密码，并确保今后更新的登录邮箱、名称、头像等资料的有效性和合法性。若您提供任何违法、虚假、不道德或西研院认为不适合在TWiRLs<span class="transform">棍棍</span>上展示的资料；或者西研院有理由怀疑您的资料属于病毒程序或恶意操作；或者您违反本服务条款的规定；或者未经西研院同意，将TWiRLs<span class="transform">棍棍</span>用于商业目的，西研院有权暂停或终止您的帐号，并拒绝您于现在和未来使用服务之全部或任何部分。
</div>
<div><span>尽管有前述规定，西研院无义务对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核实任何登记资料的真实性、准确性、完整性、适用性及/或是否为最新资料的责任。同时，西研院建议您妥善保管您的注册账号、密码和邮箱，准确输入该等信息将作为您访问登录TWiRLs<span class="transform">棍棍</span>并享有服务的关键环节。如果您发现有人未经授权使用您的帐户信息或怀疑任何人在未经授权的情况下，能够访问您的私有内容，您应立即更改密码，并向我们反馈。</span><span class="underline strong">如果您提供的信息不正确或您未能确保您的帐户信息的安全而造成任何损失或损害，西研院不承担任何责任。</span></div>
<div>&emsp;&emsp;<span>3.版权</span></div>
<div>&emsp;&emsp;TWiRLs<span class="transform">棍棍</span>的外观设计、计算机代码与专利等知识产权均归西研院所有。未经西研院事先书面许可，您不能复制、拷贝、或者使用任何部分的代码和外观设计。</div>
<div>&emsp;&emsp;<span>4.隐私政策</span></div>
<div>&emsp;&emsp;使用TWiRLs<span class="transform">棍棍</span>和西研院提供的服务，即表示您同意西研院合法收集和使用有关您及您所使用服务的技术性或诊断性信息。收集到的这些信息将用于改进TWiRLs<span class="transform">棍棍</span>产品的内容和技术，提升TWiRLs<span class="transform">棍棍</span>的服务品质。</div>
<div><span>&emsp;&emsp;</span><span class="underline strong">西研院不会将您的信息和内容提供或出售给其他的组织或个人，但以下情况除外：</span></div>
<div><span>&emsp;&emsp;</span><span class="underline strong">（1）您的事先同意或授权，或您于TWiRLs<span class="transform">棍棍</span>上主动与第三方进行分享操作；</span></div>
<div><span>&emsp;&emsp;</span><span class="underline strong">（2）司法机关或有权政府机构或任何法律法规部门规章要求西研院提供该等信息；</span></div>
<div><span>&emsp;&emsp;</span><span class="underline strong">（3）您违反了本服务条款，且西研院需要向第三方提供的。</span></div>
<div>&emsp;&emsp;<span>5.数据安全</span></div>
<div>
&emsp;&emsp;西研院将尽合理的努力保护您的信息安全，并为此采取合理的数据传输、存储、转换等预防保护措施。但是，互联网数据传输、存储、转换均可能存在一定未知且不确定的数据安全风险，该等风险将导致包括但不限于数据丢失、泄露、损坏、无法读取或提取等后果。<span class="underline strong">您确认，您已明确知晓并同意接受该等因互联网引发的风险和后果，并已采取恰当的措施（例如数据备份等），以便在该等风险发生时将损失降至最低。</span>
</div>
<div><span>&emsp;&emsp;</span><span class="underline strong">因互联网技术本身等非西研院主观故意或重大过失导致危害您数据安全的，西研院不承担任何赔偿责任。因西研院重大过失危害您数据安全的，西研院的赔偿责任以向您收取的服务费用为上限。</span></div>
<div>&emsp;&emsp;<span>6.免责声明</span></div>
<div><span>&emsp;&emsp;</span><span class="underline strong">一旦您注册成为用户即表示您与西研院达成协议，完全接受本服务条款项下的全部条款。对免责声明的解释、修改及更新权均属于西研院所有。</span></div>
<div><span>&emsp;&emsp;</span><span class="underline strong">（1）由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人信息的泄漏，或其他非因西研院原因导致的个人信息的泄漏，西研院不承担任何法律责任；</span></div>
<div><span>&emsp;&emsp;</span><span class="underline strong">（2）任何第三方根据西研院各服务条款及声明中所列明的情况使用您的个人信息，由此所产生的纠纷，西研院不承担任何法律责任以及连带责任；</span></div>
<div><span>&emsp;&emsp;</span><span class="underline strong">（3）任何由于黑客攻击、电脑病毒侵入或政府管制而造成的暂时性网站关闭，西研院不承担任何法律责任；</span></div>
<div>&emsp;&emsp;<span>7.服务变更/中断/终止</span></div>
<div>&emsp;&emsp;如因系统维护或升级的需要而暂停网络服务、调整服务功能的，西研院将尽可能事先在网站上进行通告。</div>
<div><span>&emsp;&emsp;</span><span class="underline strong">如发生下列任何一种情形，西研院有权单方面中断或终止向用户提供服务而无需通知用户：</span></div>
<div><span>&emsp;&emsp;</span><span class="underline strong">（1）用户提供的个人资料不真实；</span></div>
<div><span>&emsp;&emsp;</span><span class="underline strong">（2）用户违反本服务条款中规定的使用规则；</span></div>
<div><span>&emsp;&emsp;</span><span class="underline strong">（3）未经西研院同意，将TWiRLs<span class="transform">棍棍</span>用于商业目的。</span></div>
<div><span>&emsp;&emsp;</span><span class="underline strong">（4）禁止在未经预先书面授权的情况下销售或转卖西研院的付费服务（包括但不限于会员权益）。如果发现存在未经西研院预先书面授权转售西研院产品的行为，西研院有权追究其的法律责任。同时，西研院有权调查任何通过不正当手段获取会议权限的情况，一经发现，西研院有权收回用户已获得的奖励、权益，情节严重的，西研院将冻结其账号或者封号，西研院有权采用以上一种或多种的方式对违规用户进行处理。</span></div>
<div>&emsp;&emsp;<span>8.服务条款的完善和修改</span></div>
<div>&emsp;&emsp;西研院有权根据互联网行业变化以及有关法律、法规的颁布、修订，不时地完善和修改西研院服务条款。西研院保留随时修改服务条款的权利，用户在使用西研院的服务时，有必要对西研院最新的服务条款进行仔细阅读和重新确认，当发生相关争议时，以最新的服务条款为准。</div>
<div>&emsp;&emsp;<span>9.特别约定</span></div>
<div>&emsp;&emsp;本服务条款及其下的服务受中华人民共和国法律管辖，并按之解释。用户使用本服务的行为若有任何违反国家法律法规或侵犯任何第三方合法权益的情形，西研院有权直接删除该等违反规定的信息，并可以暂停或终止向该用户提供服务。</div>
<div>&emsp;&emsp;若用户利用本服务从事任何违法或侵权行为，由用户自行承担全部责任，西研院不承担任何法律责任及连带责任。因此给西研院或任何第三方造成任何损失的，用户应负责全额赔偿。</div>
<div><span>&emsp;&emsp;</span><span class="underline strong">用户在此特别声明并承诺，用户已充分注意本服务协议内免除或限制西研院责任的条款，用户完全知晓并理解该等条款的规定并同意接受。</span></div>
<div>&emsp;&emsp;<span>10.联系我们</span></div>
<div>&emsp;&emsp;欢迎您对我们的服务条款提出意见。如有任何问题、意见或疑虑，请电话联系：023-65298499</div>
<div>&emsp;&emsp;©中科计算技术西部研究院保留一切权利。</div>
</>`
//套餐背景
const backgroundPictrue = [
    '/img/pay/pay-price-bg1.png',
    '/img/pay/pay-price-bg2.png',
    '/img/pay/pay-price-bg3.png',
    '/img/pay/pay-price-bg4.png',
]
//需要渲染什么数据
function mapStateToProps(state) {
    return {
        userInfo: state
    }
}
//需要触发什么行为
function mapDispatchToProps(dispatch) {
    return {
        PayIncrease: (v) => dispatch({ type: 'change', value: v }),
    }
}
let interval = null
class index extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentSelectId: -1, //当前选中的id
            oldSelectId: 0, //上次被选中的id
            serviceVisible: false,
            payCodeVisible: false,
            agree: false,
            packageList: [], //套餐列表
            selectPackage: {},//选中的套餐
            loading: false,
            codeUrl: '', // 二维码的url
        }
    }

    getImgUrl = (index) => {
        return index % 4
    }
    showServiceModal = () => {
        this.setState({
            serviceVisible: true,
        });
    };

    handleServiceOk = e => {
        console.log(e);
        this.setState({
            serviceVisible: false,
        });
    };

    handleServiceCancel = e => {
        console.log(e);
        this.setState({
            serviceVisible: false,
        });
    };
    changeSelect = (ele) => {
        if (this.state.currentSelectId === ele.id) {
            this.setState({
                oldSelectId: this.state.currentSelectId,
                currentSelectId: -1,
                selectPackage: ele
            })
        } else {
            this.setState({
                oldSelectId: this.state.currentSelectId,
                currentSelectId: ele.id,
                selectPackage: ele
            })
        }

    }
    showPayCodeModal = async () => {
        //获取选中套餐的uuid
        const packageUuid = this.state.selectPackage.uuid
        const param1 = {
            packageUuid: packageUuid,
            userUuid: this.props.userInfo.uuid
        }
        if (this.state.agree === false) {
            message.warning('请先同意《升级服务条款》！')
            return
        }
        if (this.state.currentSelectId === -1) {
            message.warning('请先选择套餐！')
            return
        }
        console.log('param1', param1)
        this.setState({ loading: true });
        // 1.向后端发起请求获取微信支付的url
        const res1 = await https.post(Urls.getCodeUrl, param1)
        console.log('res', res1)

        if (res1.success) {
            this.setState({
                codeUrl: res1.data.codeUrl,
                payCodeVisible: true,
                loading: false
            });
            // 2.获取到url后转换成二维码
            // 3.之后一直调用接口  判断是否支付完成  显示状态
            const param2 = {
                tradeOrderNo: res1.data.tradeOrderNo
            }
            // let res2
            // do {
            //     res2 = await https.post(Urls.getPayRecord, param2)
            //     if (res2.data[0].orderState === '已支付') {
            //         message.success('支付成功')
            //         this.props.history.push("/service/search");
            //         return
            //     }
            // } while (res2.success && res2.data[0].orderState !== '已支付')

            interval = setInterval(async () => {
                const res2 = await https.post(Urls.getPayRecord, param2)
                // console.log('res2.data[0].orderState', res2.data[0].orderState)
                if (res2.success) {
                    if (res2.data[0].orderState === '已支付') {
                        clearInterval(interval)
                        message.success('支付成功')
                        this.props.history.push("/service/search");
                    }
                }
            }, 1000)
            // 4.支付成功  如果来自服务页面  则继续搜索  否则跳回服务页面
        } else {
            //提示错误
            console.log('res1', res1)
            message.error(`${res1.errMsg}`)
            this.setState({
                loading: false
            })
        }

    };

    handlePayCodeOk = e => {
        console.log(e);
        this.setState({
            payCodeVisible: false,
        });
    };

    handlePayCodeCancel = e => {
        this.setState({
            payCodeVisible: false,
        });

        if (clearInterval) {
            clearInterval(interval)
        }

    };
    changeAgree = (e) => {
        this.setState({
            agree: e.target.checked
        })
    }
    // 获取套餐列表
    getPackageList = async () => {
        const param = {
            isAvailable: 1
        }
        const res = await https.get(Urls.getPackageList, param)
        console.log('res.data.data', res.data);
        if (!res.success) {
            message.error('获取套餐信息失败')
            return
        }
        let showPackageList = res.data.data.filter((ele) => {
            return ele.isDisplay === 1
        })
        console.log('showPackageList', showPackageList)
        //找出推荐套餐

        console.log('showPackageList', showPackageList)
        let recommendPackage = res.data.data.filter((ele) => {
            return ele.isRecommend === 1
        })

        if (recommendPackage.length === 0) {
            this.setState({
                packageList: showPackageList,
                currentSelectId: -1
            })
        } else {
            this.setState({
                packageList: showPackageList,
                selectPackage: recommendPackage[0],
                currentSelectId: recommendPackage[0].id
            })
        }

    }
    componentDidMount() {
        this.getPackageList();
    }
    render() {
        return (
            <React.Fragment >
                <Spin tip="数据提交中..." spinning={this.state.loading}>
                    {JSON.stringify(this.props.userInfo) !== "{}" &&
                        <div className="pay-content">
                            <div className="pay-head">
                                <img src="/img/pay/pay-head.png" alt="" />
                            </div>
                            <div className="select-price">
                                {
                                    this.state.packageList.map((ele, index) => {
                                        return (
                                            <div className={this.state.currentSelectId === ele.id ? 'item selected' : this.state.oldSelectId === ele.id ? 'item old-selected' : 'item'} onClick={() => { this.changeSelect(ele) }} key={index}>
                                                <div className="img-head">
                                                    <img src={backgroundPictrue[this.getImgUrl(index)]} alt="" />
                                                    <div className="text"><span>{ele.name.slice(0, -3)}</span> {ele.name.slice(-3)}</div>
                                                </div>
                                                <div className="price">
                                                    <div className="new-price">￥{this.props.userInfo?.extendFieldMap?.userType === '1' ? ele.enterpriseCurrentPrice : ele.personalCurrentPrice}</div>
                                                    <div className="old-price">￥{ele.originalPrice}</div>
                                                </div>
                                                <div className="img-footer">
                                                    <img src="/img/pay/pay-price-logo.png" alt="" />
                                                </div>
                                                <div className="discount">
                                                    <img src="/img/pay/pay-price-discount.png" alt="" />
                                                    <div className="discount-text">{((this.props.userInfo?.extendFieldMap?.userType === '1' ? ele.enterpriseCurrentPrice : ele.personalCurrentPrice) / ele.originalPrice).toFixed(2) * 10} <span>折</span></div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }

                            </div>

                            <div className="tip">*所有升级套餐使用年限均为1年</div>
                            <div className="pay-method">
                                <span>支付方式：</span>
                                <div className="weChat-pay-img">
                                    <img src="/img/pay/pay-weChat-pay.png" alt="" />
                                </div>
                            </div>
                            <div className="agree">
                                <Checkbox onChange={this.changeAgree}><span>我已认真阅读并同意<a href="#" onClick={this.showServiceModal}>《升级服务条款》</a>，支持开具发票，可以在<a href="/personal/trade">账户中心-交易明细</a>中开具</span></Checkbox>
                            </div>
                            <button className="pay-upgrade" onClick={this.showPayCodeModal}>立即付费升级</button>
                            <div className="phone-num">如有疑问联系客服，客服电话：023-65781234</div>
                            <Modal bodyStyle={{ height: '500px', overflow: 'auto' }}
                                title="服务条款"
                                visible={this.state.serviceVisible}
                                onOk={this.handleServiceOk}
                                onCancel={this.handleServiceCancel}
                                width='800px'
                                footer={[]}
                            >

                                <div dangerouslySetInnerHTML={{ __html: serviceContent }}></div>
                            </Modal>
                            <Modal
                                title="微信支付"
                                visible={this.state.payCodeVisible}
                                onOk={this.handlePayCodeOk}
                                onCancel={this.handlePayCodeCancel}
                                footer={[]}
                            >
                                <div style={{ textAlign: 'center' }}>
                                    <h2 className="selected-name">套餐名称：{this.state.selectPackage.name}</h2>
                                    <div style={{ marginBottom: '15px' }} className="selected-price">应付金额￥{this.props.userInfo.extendFieldMap.userType === '1' ? this.state.selectPackage.enterpriseCurrentPrice : this.state.selectPackage.personalCurrentPrice}</div>
                                    <QRCode
                                        id="bill_qr_code_url"
                                        value={this.state.codeUrl} //value参数为生成二维码的链接 我这里是由后端返回
                                        size={200} //二维码的宽高尺寸
                                        fgColor="#000000"  //二维码的颜色
                                    />
                                    <div style={{ color: '#2db55d', marginTop: '30px' }}>请用微信扫描支付</div>
                                </div>
                            </Modal>
                        </div>
                    }
                </Spin>
            </React.Fragment >
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(index));